import store from "@/store";
import { OpportunityData } from "@/models/OpportunityData";
import { OpportunityService } from "@/services/OpportunityService";
import { BaseChildDocumentStore } from "./BaseChildDocumentStore";
import { ClientData } from "@/models/ClientData";
import { clientsStore } from "./ClientStore";
import { Action } from "vuex-class-modules";
import { globalStore } from "./GlobalStore";
import _ from "lodash";
import { OpportunityStatus } from "@/enums/OpportunityStatus";
import { InForceProductGroup } from "@/enums/InForceProductGroup";

class OpportunityStore extends BaseChildDocumentStore<
  OpportunityData,
  ClientData,
  OpportunityService
> {
  parent: ClientData = new ClientData();
  entities: OpportunityData[] = [];
  inForceEntities: OpportunityData[] = [];
  current: OpportunityData = new OpportunityData();
  newEntity(): OpportunityData {
    return new OpportunityData();
  }

  get service(): OpportunityService {
    return new OpportunityService();
  }

  @Action
  async getAll(): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      const items = await this.service.getAll();
      this.entities = items
        .map((x) => _.merge(this.newEntity(), x))
        .filter(
          (x) =>
            x.status !== OpportunityStatus.INFORCE &&
            x.status !== OpportunityStatus.FILE_CLOSED,
        );
      this.inForceEntities = items
        .map((x) => _.merge(this.newEntity(), x))
        .filter((x) => x.status === OpportunityStatus.INFORCE);
    } finally {
      globalStore.setIsBusy(false);
    }
  }
  get totalLifePolicies(): number {
    return _.size(
      this.inForceEntities.filter((d) => d.opportunityProductLine === InForceProductGroup.LIFE)
    );
  }

  get totalAnnuityPolicies(): number {
      return _.size(
        this.inForceEntities.filter((d) => d.opportunityProductLine === InForceProductGroup.ANNUITY)
      );
    }
    get totalCount():number{
      return this.inForceEntities.length
     }
  @Action
  async getByClientId(id: string): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      const items = await this.service.getByClientId(id);
      const list = items.map((x) => _.merge(this.newEntity(), x));
      this.entities = list.filter(
        (y) =>
          y.status !== OpportunityStatus.INFORCE &&
          y.status !== OpportunityStatus.FILE_CLOSED
      );
      this.inForceEntities = list.filter(
        (y) => y.status === OpportunityStatus.INFORCE
      );
    } finally {
      globalStore.setIsBusy(false);
    }
  }
}
export const opportunityStore = new OpportunityStore({
  store,
  name: "opportunities",
});

clientsStore.$watch(
  (c) => c.current,
  (newValue) => {
    opportunityStore.setParent(newValue);
  }
);
